import * as Styled from './styled';
import React, { FC, cloneElement } from 'react';
import FieldLabel from '../../ClientDataExchange/Common/FieldLabel';

type Props = {
	mode?: string;
	label: string;
	children: JSX.Element | JSX.Element[];
};

const Card: FC<Props> = ({ mode, label, children }) => {
	return (
		<Styled.Card
			data-id={`card-${mode}`}
			mode={mode as string}
			display="grid"
			marginTop={6}
			marginBottom={6}
			paddingTop={6}
			paddingBottom={6}
			paddingRight={4}
			paddingLeft={4}
		>
			<div>
				<FieldLabel>{label}</FieldLabel>
			</div>
			{children}
		</Styled.Card>
	);
};

Card.defaultProps = {
	mode: 'view',
};

export default Card;
